import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import qs from 'qs';
import { useHistory, useLocation } from 'react-router-dom';
import { useQuery, useMutation } from '@apollo/client';
import {
  CenteredLoader as Loader,
  ErrorHandler,
  captureException,
} from '@playbookux/playbook-web-core';
import {
  Logo, LogoContainer, Segment, UpperBar, PageContainer,
} from './styles';
import ConsentFormPrompt from '../../components/consent-form-prompt';
import { TESTER_CONSENT_FORMS } from './graphql';
import { CONSENT_FORM_ANSWER_BY_TESTER_ID } from '../../../core/graphql/screener-sessions';

const disqualifiedPath = '/screener-session/disqualified';
const disqualifiedStatus = 'disqualified';

const ConsentForm = () => {
  const { search, hash } = useLocation();
  const history = useHistory();
  const { testerId } = qs.parse(search, { ignoreQueryPrefix: true });
  const redirectPath = _.last(hash.split('#'));

  const [answerConsentFormMutation] = useMutation(CONSENT_FORM_ANSWER_BY_TESTER_ID);

  const [savingResponse, setSavingResponse] = useState(false);
  const [savingResponseError, setSavingResponseError] = useState(false);

  const {
    data: testerData = {},
    loading: loadingTester,
    error: testerError,
  } = useQuery(TESTER_CONSENT_FORMS, {
    variables: { id: testerId },
  });

  const testerStatus = _.get(testerData, 'tester.status');

  const consentForms = (
    _.get(testerData, 'tester.project.projectConsentForms', [])
      .map(({ consentForm }) => consentForm)
  );

  const handleSubmitAnswer = async (acceptsConsentForms) => {
    if (testerData && testerData.tester) {
      try {
        setSavingResponse(true);

        // backend will deal the logic of when updating to qualified or not.
        await answerConsentFormMutation({
          variables: {
            status: acceptsConsentForms ? 'qualified' : disqualifiedStatus,
            testerId,
          },
        });

        if (acceptsConsentForms) {
          history.push(redirectPath);
        } else {
          history.push(disqualifiedPath);
        }
      } catch (e) {
        captureException('ANSWER_CONSENT_FORM_ERROR', e);
        setSavingResponseError(e.message);
      } finally {
        setSavingResponse(false);
      }
    }
  };

  useEffect(() => {
    if (testerStatus === disqualifiedStatus) {
      history.push(disqualifiedPath);
    }
  }, [testerStatus, history]);

  if (loadingTester || savingResponse) {
    return <Loader active data-loader="consent-loader" />;
  }

  if (testerError) {
    return (
      <ErrorHandler
        error={testerError}
        defaultMessage="There was a problem while fetching project information."
      />
    );
  }

  return (
    <PageContainer>
      <LogoContainer>
        <Logo src="/images/playbook-logo.png" />
      </LogoContainer>
      <Segment>
        <UpperBar />
        <ConsentFormPrompt
          onSubmitAnswer={handleSubmitAnswer}
          consentForms={consentForms}
        />
        {(savingResponseError) && (
          <ErrorHandler
            error={savingResponseError}
            defaultMessage="There was a problem while fetching consent form information."
          />
        )}
      </Segment>
    </PageContainer>
  );
};

export default ConsentForm;
